import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ArrowRight, Shield, Zap, Award } from 'lucide-react';
import { settingsAPI } from '../services/api';

const fontMap = {
  system: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
  serif: 'Georgia, Times New Roman, serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
};

export const HeroSection = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const s = await settingsAPI.getPublic();
        setSettings(s);
      } catch {
        setSettings(null);
      }
    };
    load();
  }, []);

  const scrollToContact = () => { document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); };
  const scrollToProducts = () => { document.querySelector('#products')?.scrollIntoView({ behavior: 'smooth' }); };

  const title1 = settings?.title_line1 || 'Solutions Énergétiques';
  const title2 = settings?.title_line2 || 'Haute Performance';
  const subtitle = settings?.subtitle || "Distributeur et Représentant Officiel EXCLUSIF PowMr spécialisé en batteries lithium et convertisseurs hybrides. L'excellence sans compromis pour vos projets énergétiques en France et en Afrique.";
  const align = settings?.align || 'center';
  const veil = typeof settings?.veil_intensity === 'number' ? settings.veil_intensity : 70;
  const heroUrl = settings?.hero_image_url || '/assets/hero/exemple-parfait.webp';
  const fontFamily = fontMap[settings?.font_family || 'system'];
  const title1Color = settings?.title1_color || '#111111';
  const title2Color = settings?.title2_color || '#111111';
  const subtitleColor = settings?.subtitle_color || '#111111';

  const textAlignCls = align === 'left' ? 'text-left mx-auto md:mx-0' : 'text-center mx-auto';

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-white" style={{ fontFamily }}>
      {/* Background image from settings */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-center bg-cover bg-fixed-desktop" style={{ backgroundImage: `url('${heroUrl}')` }} />
        <div className="absolute inset-0" style={{ background: `linear-gradient(90deg, rgba(255,255,255,${Math.min(0.95, (veil+25)/100)}), rgba(255,255,255,${Math.min(0.85, veil/100)}), rgba(255,255,255,0))` }} />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`max-w-4xl ${textAlignCls}`}>
          <Badge className="mb-6 bg-gradient-to-r from-yellow-100 to-yellow-200 text-gray-800 px-4 py-2 text-sm font-medium border border-yellow-300 inline-flex items-center">
            <Award className="w-4 h-4 mr-2" />
            Distributeur et Représentant Officiel EXCLUSIF PowMr - Mali
          </Badge>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold drop-shadow mb-6 leading-tight" style={{ color: title1Color }}>
            {title1}
            <span className="block drop-shadow" style={{ color: title2Color }}>{title2}</span>
          </h1>

          <p className={`hero-sub text-xl sm:text-2xl drop-shadow mb-8 max-w-3xl leading-relaxed ${align==='center'?'mx-auto text-center':''}`} style={{ color: subtitleColor }}>
            {subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-start justify-center">
            <Button onClick={scrollToContact} size="lg" className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold px-8 py-4 text-lg rounded-xl transition-all duration-300 hover:scale-105 shadow-lg group border-0">Demander un devis gratuit<ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" /></Button>
            <Button onClick={scrollToProducts} variant="outline" size="lg" className="border-2 border-gray-300 text-gray-700 hover:bg-gray-50 font-semibold px-8 py-4 text-lg rounded-xl transition-all duration-300 hover:scale-105 bg-white/80">Découvrir nos produits</Button>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">Présents en France et au Mali</p>
            <div className="flex flex-wrap items-center gap-8 text-gray-400 justify-center">
              <div className="flex items-center space-x-2"><div className="w-2 h-2 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-full" /><span className="text-sm font-medium">Moisenay, France</span></div>
              <div className="flex items-center space-x-2"><div className="w-2 h-2 bg-gradient-to-r from-gray-600 to-gray-700 rounded-full" /><span className="text-sm font-medium">Bamako, Mali</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};